import { callHandlerConfig } from '@hst/utils';
import dayjs from 'dayjs';

export function mergeAdjacentNewsItems(array) {
	const result = [];
	let tempGroup = null;

	for (let i = 0; i < array.length; i++) {
		const currentItem = array[i];

		if (currentItem.compType === 'news') {
			// 如果是 news 类型，直接创建或添加到分组
			if (!tempGroup) {
				tempGroup = {
					compType: 'newsList',
					subs: [currentItem],
				};
			} else {
				tempGroup.subs.push(currentItem);
			}
		} else {
			// 如果不是 news 类型，先处理可能存在的分组
			if (tempGroup) {
				result.push(tempGroup);
				tempGroup = null;
			}
			result.push(currentItem);
		}
	}

	// 处理循环结束后可能存在的分组（单个或多个 news）
	if (tempGroup) {
		result.push(tempGroup);
	}

	return result;
}

// 原始 user agent
export const UA = navigator.userAgent || ''; // 服务器无法独立获取

// user agent 小写化
export const ua = UA.toLowerCase();

/**
 * 获取user-agent版本
 * @returns {string}
 */
export function uaVersion(tester, _ua = ua) {
	const idx = _ua.indexOf(tester);
	if (idx < 0) {
		return '';
	}
	// ["[hstong/1.4.500]", "hstong/1.4.500", "hstong", "1.4.500"]
	const re = new RegExp(`[\\[\\s]((${tester})\\/([\\d\\.]+))(?:\\]|\\s|$)`, 'i');
	const arr = _ua.match(re) || [];
	return arr.length === 4 ? arr[3] : '';
}

/**
 * 比较两个版本
 * @returns {number} -1/1/0
 */
export function appVersionComparator(v1, v2) {
	v1 = v1.trim();
	v2 = v2.trim();

	if (!v1 || !v2) {
		return false;
	}

	const regex = /^(0|[1-9]\d*)\.(0|[1-9]\d*)(\.\d+)*$/;
	if (!regex.test(v1) || !regex.test(v2)) {
		return false;
	}

	const v1Strs = v1.split('.');
	const v2Strs = v2.split('.');
	if (v1Strs.length > v2Strs.length) {
		const len = v1Strs.length - v2Strs.length;
		for (let i = 0; i < len; i++) {
			v2Strs.push(0);
		}
	}

	if (v1Strs.length < v2Strs.length) {
		const len = v2Strs.length - v1Strs.length;
		for (let i = 0; i < len; i++) {
			v1Strs.push(0);
		}
	}

	for (let i = 0; i < v1Strs.length; i++) {
		const v1Val = +v1Strs[i];
		const v2Val = +v2Strs[i];
		if (v1Val === v2Val) {
			continue;
		} else if (v1Val < v2Val) {
			return -1;
		} else if (v1Val > v2Val) {
			return 1;
		}
	}
	return 0;
}

export function getAppConfig() {
	return callHandlerConfig().then((data) => {
		const config = data || {};
		console.log('---getAppConfig---:', config);
		// app路径记录，通过桥获取
		let pathChainRecord = config['Path_Chain_Record'];
		if (pathChainRecord) {
			const _appVersion = uaVersion('hstong');
			// APP为了方便，从2.5.400版本开始讲整个参数转成JSON字符串;
			if (appVersionComparator(_appVersion, '2.5.400') >= 0) {
				pathChainRecord = JSON.parse(pathChainRecord);
			}
		}
		return pathChainRecord;
	});
}

const isWINRegx = /w(i|o)(w|n)(32|64)/i;

// 是否在windows环境中
export function isWin(_ua = ua) {
	const test = isWINRegx.test(_ua);
	return test;
}

// 通过cookie判断用户设置的 红涨绿跌 还是 红跌绿涨
export function appUpDownColorType(COOKIE = '') {
	// hs_h5_colorType  0: 红涨绿跌 1: 红跌绿涨
	let reg = new RegExp('(^| )hs_h5_colorType=([^;]*)(;|$)');
	let arr;
	if (!COOKIE) {
		COOKIE = document.cookie;
	}
	if ((arr = COOKIE.match(reg))) {
		return arr[2];
	}
	return '0';
}

/**
 * 判断并获取股票涨跌状态 -1 跌了， 0 不涨不跌，1 涨了
 * @param {Object} stock = stockItem
 */
export function stockUpDownStatus(stock) {
	const status = parseInt(stock.status);
	if (status === 1 || status === 2) {
		// 停牌或者暂停交易
		return 0;
	}
	// status = 0,3,其他值
	let upDown = stock.highAndLowLimited;
	if (upDown === '' || upDown === void 0 || upDown === null) {
		upDown = '0';
	}
	upDown = parseFloat(upDown);
	if (upDown < 0) {
		// 跌
		return -1;
	}
	if (upDown === 0) {
		// 不涨不跌
		return 0;
	}
	if (upDown > 0) {
		// 涨
		return 1;
	}
}

const StockStatusEnum = {
	red: 'red',
	green: 'green',
	gray: 'gray',
};

/**
 * 获取股票涨跌状态
 * @param {Object} stock = stockItem
 */
export function stockStatus(stock) {
	let up;
	let down;
	if (appUpDownColorType() === '0') {
		// 0: 红涨绿跌 1: 红跌绿涨
		up = StockStatusEnum.red;
		down = StockStatusEnum.green;
	} else {
		up = StockStatusEnum.green;
		down = StockStatusEnum.red;
	}
	const statusCode = stockUpDownStatus(stock);
	if (statusCode === -1) {
		// 跌
		return down;
	}
	if (statusCode === 0) {
		// 不涨不跌
		return StockStatusEnum.gray;
	}
	if (statusCode === 1) {
		// 涨
		return up;
	}
}

/**
 * 获取股票涨跌数值
 * @param {Object} stock = stockItem
 * @returns
 */
export function stockNumText(stock) {
	const status = parseInt(stock.status);
	if (status === 1) {
		return '停牌';
	}
	if (status === 2) {
		return '暂停交易';
	}
	let upDown = stock.highAndLowLimited;
	const statusCode = stockUpDownStatus(stock);
	if (statusCode === -1) {
		// 跌
		return `${upDown}%`;
	}
	if (statusCode === 0) {
		// 不涨不跌 或停牌 或无权限查看
		if (upDown === void 0 || upDown === null) {
			upDown = '0';
			upDown = parseFloat(upDown).toFixed(2);
			upDown = `${upDown}%`;
		} else if (upDown == '0.00') {
			upDown = `${upDown}%`;
		}
		return upDown;
	}
	if (statusCode === 1) {
		// 涨
		return `+${upDown}%`;
	}
}

/**
 * 格式化时间字符串
 * @param timeStr 时间字符串，格式为 'YYYYMMDD HH:mm:ss'，例如 '20250326 16:53:26'
 * @returns 格式化后的时间字符串
 */
export function formatTime(timeStr, t) {
	// 解析输入的时间字符串（手动格式化为 dayjs 可识别的格式）
	const formattedTimeStr = `${timeStr.substring(0, 4)}-${timeStr.substring(4, 6)}-${timeStr.substring(6, 8)} ${timeStr.substring(9)}`;
	const inputDate = dayjs(formattedTimeStr);
	const now = dayjs();

	// 计算时间差（毫秒）
	const diffMs = now.diff(inputDate);
	const diffMinutes = Math.floor(diffMs / (1000 * 60));

	// 判断逻辑（完全基于 dayjs 自带方法）
	if (diffMinutes < 1) {
		return t('just');
	} else if (diffMinutes < 60) {
		return `${diffMinutes}${t('minutesAgo')}`;
	} else if (inputDate.isSame(now, 'day')) {
		// 判断是否是今天
		return `${t('today')} ${inputDate.format('HH:mm')}`;
	} else if (inputDate.isSame(now, 'year')) {
		// 判断是否是同一年
		return inputDate.format('MM-DD HH:mm');
	} else {
		return inputDate.format('YYYY-MM-DD HH:mm');
	}
}

/**
 * 根据市场类型和分类获取对应的 dataType
 * @param {string} category - 分类类型，'1' 表示行业，'2' 表示概念
 * @param {string} marketType - 市场类型，'1' 表示港股，'2' 表示美股，'3' 表示A股
 * @returns {string|null} 返回对应的 dataType 字符串，如果参数无效则返回 null
 */
export function getDataType(category, marketType) {
	// 定义映射关系
	const dataTypeMap = {
		1: {
			// 行业
			1: '10006', // 港股行业
			2: '20006', // 美股行业
			3: '30006', // A股行业
		},
		2: {
			// 概念
			1: '10007', // 港股概念
			2: '20007', // 美股概念
			3: '30007', // A股概念
		},
	};

	// 检查输入是否有效，无效则返回 null
	if (!dataTypeMap[category] || !dataTypeMap[category][marketType]) {
		return null;
	}

	// 返回对应的 dataType
	return dataTypeMap[category][marketType];
}
